module.exports = __webpack_public_path__ + "static/media/upgrade.8a7ba728.svg";